import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components/home/buttons';
import { GetLocalStorage, LocalStorageKeyName } from '@/util/local-storage.ts';

export function HomeRoute() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const storedId = GetLocalStorage(LocalStorageKeyName.GameId);

    function onNavigate(path: 'game' | 'create' | 'join', replace = false) {
        if (path === 'game') {
            if (storedId) {
                navigate(`/${path}/${storedId}`, { replace });
            }
        } else {
            navigate(`/${path}`, { replace });
        }
    }

    return (
        <div className="flex flex-col">
            <div className="flex flex-col items-stretch space-y-4 animate-puff-in-center">
                {!!storedId && <Button hotkey={{ key: '0', display: '⓪' }} onClick={() => onNavigate('game')}>{t('home.btnReturnToGame')}</Button>}
                <Button hotkey={{ key: '1', display: '①' }} onClick={() => onNavigate('create')}>{t('home.btnNewGame')}</Button>
                <Button hotkey={{ key: '2', display: '②' }} variant="secondary" onClick={() => onNavigate('join')}>{t('home.btnJoinGame')}</Button>
            </div>
            {/*
            <div className="mt-[4vh] flex flex-col items-stretch animate-puff-in-center">
                <Button variant="secondary" onClick={() => onNavigate('/singleplayer')}>{t('home.btnSinglePlayer')}</Button>
            </div>
            */}
        </div>
    );
}
